<ng-container>
  <span mat-dialog-title class="modal-header">
    <span>
      <i class="material-icons" style="font-size: 18px">filter_list</i> Filter Pipelines
    </span>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </span>
  <div mat-dialog-content>
    <div class="row space-between" style="margin-top: 10px">
      @if(!isGlobal && (hasPermissionEdit || isOwner)){
        <button [disabled]="!pipelineNameFormControl.value || baseViewFormControl.invalid || groupingControl.invalid" mat-flat-button class="filter-button save" (click)="savePipelineFilter()">Save Pipeline<mat-icon>save</mat-icon></button>
      }
<!--      @if(!data?.pipeline.pipeline_view_filter_id || isGlobal){-->
        <button [disabled]="!pipelineNameFormControl.value || baseViewFormControl.invalid || groupingControl.invalid" mat-flat-button class="filter-button save" (click)="savePipelineFilter(true)">Save Pipeline As<mat-icon>save</mat-icon></button>
<!--      }-->
      <button mat-flat-button class="filter-button clear" (click)="clearFilterData()">Clear Data<mat-icon>playlist_remove</mat-icon></button>
    </div>
    <div class="row" style="margin-top: 10px">
      <mat-form-field>
        <mat-label>Pipeline Name</mat-label>
        <input matInput type="text" placeholder="Enter a name for the Pipeline" [formControl]="pipelineNameFormControl">
      </mat-form-field>
      @if(searchResults.length>0){
        <li class="row pipeline-names-list">
          Similar Pipelines:
          @for(result of searchResults; track result.id){
            <ul>{{result.name}}</ul>
          }
        </li>
      }
      @if(canLinkInvestor){
        <mat-form-field>
          <mat-label>Link an investor...</mat-label>
          <input matInput type="text" [formControl]="investorControl" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-optgroup label="Sponsors">
              @for(sponsor of investorResults.sponsors; track $index){
                <mat-option [value]="sponsor">{{sponsor.name}}</mat-option>
              }
            </mat-optgroup>
            <mat-optgroup label="Organizations">
              @for(organization of investorResults.orgs; track $index){
                <mat-option [value]="organization">{{organization.name}}</mat-option>
              }
            </mat-optgroup>
          </mat-autocomplete>
        </mat-form-field>
      }
      @if(!hasJsonGroup){
        <mat-form-field>
          <mat-label>Pipeline Grouping</mat-label>
          <mat-select [formControl]="groupingControl" (selectionChange)="onGroupChange($event)">
            @for(group of groupings; track group.id){
              <mat-option [value]="group">{{group.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if(hasJsonGroup){
        <div class="row space-between">
          <div class="col-md-5">
            <div class="row gutter">
              <mat-form-field>
                <mat-label>Pipeline Grouping</mat-label>
                <mat-select [formControl]="groupingControl" (selectionChange)="onGroupChange($event)">
                  @for(group of groupings; track group.id){
                    <mat-option [value]="group">{{group.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <mat-form-field>
                <mat-select [formControl]="jsonGroupControl" (selectionChange)="onGroupChange($event, true)" [compareWith]="compareGroups">
                  @for(jgroup of jsonGroupings; track jgroup.id){
                    <mat-option [value]="jgroup">{{jgroup.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>
      }
      <mat-form-field>
        <mat-label>Base Pipeline View</mat-label>
        <mat-select [formControl]="baseViewFormControl" placeholder="Select base pipeline view">
          @for(view of (pipelineService.baseViews$ | async); track view.id){
            <mat-option [value]="view">{{view.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if(showFilterBlocks){
      @for(num of conditionBlockNum; track $index){
        @if($index>0){
          <div>
          <mat-button-toggle-group class="small-toggle" [formControl]="toggleControls[$index - 1]">
            <mat-button-toggle value="{{PipelineFilterConditionType.AND}}">AND</mat-button-toggle>
            <mat-button-toggle value="{{PipelineFilterConditionType.OR}}">OR</mat-button-toggle>
          </mat-button-toggle-group>
          </div>
        }
        <div class="row">
          <pipelines-condition-block [index]="$index" (removeBlock)="removeConditionBlock($event)"></pipelines-condition-block>
        </div>
      }
      <div class="row">
        <div class="flat-transparent-button" (click)="addConditionBlock()">+ Add Condition Block</div>
      </div>
      <div class="row">
        <pipelines-sort-block></pipelines-sort-block>
      </div>
    }

  </div>
  <div mat-dialog-actions>
    <button [disabled]="baseViewFormControl.invalid || groupingControl.invalid" mat-flat-button class="filter-button view-pipeline" (click)="viewPipeline()">View Pipeline</button>
  </div>
</ng-container>
